import { render, staticRenderFns } from "./AdminEditTicket.vue?vue&type=template&id=4d7c67e6&scoped=true&"
import script from "./AdminEditTicket.vue?vue&type=script&lang=js&"
export * from "./AdminEditTicket.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditTicket.vue?vue&type=style&index=0&id=4d7c67e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7c67e6",
  null
  
)

export default component.exports